import { Button, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader } from "../../components/loader/Loader";
import CartProductCard from "./CartProductCard";
import RenderSvg from "../renderSvg/RenderSvg";
import { Divider } from "@mantine/core";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {
  getValidateRequestBody,
  isMOQEnabled,
  updateQuantityInCart,
  getOutletDetails
} from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import { ChannelkartNetworkPost } from "../../services/networkService";
import FormHeader from "../dms_common/FormHeader";
import { determineOrderType } from "../dms_common/useQuery";
import { DeliveryDetails } from "./DeliveryDetails";
import CartSummaryFooter from "../dms_common/CartSummaryFooter";
import { formatDate } from "./util";
import NewDiscountModal from "../../features/claimsNew/modals/NewDiscountModal";
import { getSkuData } from "./CartProductCardUtils";
import { useDispatch, useSelector } from "react-redux";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { getDataFromLocalDb, insertDataIntoLocalDB } from "../../services/dbService";
import { Cart, Catalogue, CartProduct } from "../../features/createSecondaryOrder/models";
import {
  GenericModal,
  getGenericModalProps,
  initialGenericModalProps,
} from "../../features/viewOrder/ViewOrderUtils";
import CustomGenericModal from "../dms_common/CustomGenericModal";
import "./Checkout.css";
import { OrderType } from "../../types/types";
import ScreenOverlay from "../dms_common/ScreenOverlay";
import { setSecondaryState } from "../../stateManagement/actions/secondaryOrderActions";
import { getConfigData } from "../../services/configurationService";
import { logLoadTrace } from "../../firebase";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { isCounterSaleOrder: boolean, outletReferenceId: string, showListView: boolean };
  const isCounterSaleOrder = state?.isCounterSaleOrder ?? false
  const outletReferenceId = state?.outletReferenceId ?? ""
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const outletId = query.get("outletId") || "null";
  const salesRepQuery = query.has("salesRep") ? query.get("salesRep") : null;
  const beatQuery = query.has("beat") ? query.get("beat") : null;
  const [cart, setCart] = useState<Cart>({});
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [placeOrderLoading, setPlaceOrderLoading] = useState<boolean>(false);
  const [genericModalProps, setGenericModalProps] =
    useState<GenericModal>(initialGenericModalProps);
  const [skuData, setSkuData] = useState<any>({});
  const disableStockCheck = useRef<boolean>(false);

  const orderType = determineOrderType(location?.pathname);

  const dispatch = useDispatch();

  const cartProducts = cart?.[outletId]?.productsMap;
  const { createNewOrderState } = useSelector((state: any) => state.secondaryOrder);

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    shippingAddressMandatory,
    fetchPricingBySalesrep
  } = ConfigDictionary;

  const designation = JSON.parse(localStorage.authContext).user.designation || [];
    
  let enableMOQCheck = false;

  const enableMOQCheckConfig = ConfigDictionary?.enableMOQCheck;
  if (enableMOQCheckConfig?.enable) enableMOQCheck = isMOQEnabled(designation, enableMOQCheckConfig)
  
  const handleCheckoutLog = async() => {
      logLoadTrace(handleCheckout,"create_secondary_order_validate_order_time");
  }
  const handleCheckout = async () => {
    setPlaceOrderLoading(true);
    const customerData = cart?.[outletId]?.customer || {};

    const shippingAddress = customerData?.shippingAddress || "";
    const billDate = formatDate(customerData?.billDate) || "";
    const deliveryDate = formatDate(customerData?.deliveryDate) || "";
    const salesRep = customerData?.selectedSalesRep || "";
    const salesType = customerData?.salesType || "";
    const customerChannel = customerData?.customerChannel || "";
    const paymentMethod = customerData?.paymentMethod || "";
    const diffShippingAddress = (createNewOrderState?.diffShippingAddress || shippingAddressMandatory);
    const showListView = (state?.showListView || false);

    const customerInfo = {
      billToAddress: shippingAddress,
      shipToAddress: cart?.[outletId]?.customer?.differentShippingAddress ?? "",
      billDate,
      deliveryDate,
      salesRep,
      salesType,
      customerChannel,
      paymentMethod,
      diffShippingAddress,
      showListView
    };

    try {
      const outletDetails = await getOutletDetails(outletId)
      const outletType = outletDetails?.[0]?.outletType ?? ""
      const requestBody = getValidateRequestBody(cart?.[outletId], undefined, true, isCounterSaleOrder, outletReferenceId,undefined, outletType);
      const response = await ChannelkartNetworkPost(
        "/orders/validate?transformerOut=orderDetailSplit",
        requestBody
      );

      if (response?.status !== 200 && response?.status !== 201) {
        setGenericModalProps(
          getGenericModalProps("error", "There is some issue while validating cart")
        );
      } else {
        navigate(`summary?orderType=${orderType}&outletId=${outletId}${(fetchPricingBySalesrep && fetchPricingBySalesrep) ? `&salesRep=${salesRepQuery}&beat=${beatQuery}` : ''}`, {
          state: {
            orderValidateRes: response?.data?.feature,
            ...customerInfo,
            skuCodeSortOrder: response?.data?.feature?.[0]?.extendedAttributes?.skuCodeSortOrder || [],
            isCounterSaleOrder: isCounterSaleOrder,
            outletReferenceId: outletReferenceId
          },
        });
      }
    } catch (error) {
      setGenericModalProps(
        getGenericModalProps("error", "There is some issue while validating cart")
      );
      console.error(error);
    } finally {
      setPlaceOrderLoading(false);
    }
  };

  const resetCart = async () => {
    setCart((prevCart) => {
      const updatedCart = {
        ...prevCart,
        [outletId]: { ...prevCart[outletId], productsMap: {} },
      };
      dispatch(
        setSecondaryState(createNewOrderState, {
          ...createNewOrderState,
          diffShippingAddress: false,
        })
      );
      insertDataIntoLocalDB("Cart", [{ id: 1, data: updatedCart }]);
      return updatedCart;
    });
    navigate(location.pathname.replace(/\/([^/]*)$/, `?outletId=${outletId}${(fetchPricingBySalesrep && fetchPricingBySalesrep) ? `&salesRep=${salesRepQuery}&beat=${beatQuery}` : ''}`), {
      state: {
        showListView: state?.showListView
      }
    });
  };

  const handleStepperBack = () => {
    navigate(location.pathname.replace(/\/([^/]*)$/, `?outletId=${outletId}${(fetchPricingBySalesrep && fetchPricingBySalesrep) ? `&salesRep=${salesRepQuery}&beat=${beatQuery}` : ''}`), {
      state: {
        showListView: state?.showListView
      }
    });
  };

  useEffect(() => {
    const getAndSetData = async () => {
      setLoading(true);
      try {
        const res3 = await getConfigData("dms_configuration", "disableStockCheck");
        disableStockCheck.current = res3[0]?.configValue ?? false;
        const responseCart = await getDataFromLocalDb("Cart");
        const batchCodes = [...Object.keys(responseCart?.data?.[0]?.data?.[outletId]?.productsMap)];
        const query = { batchCode: { $in: batchCodes } };
        const responseSelectedCatalogue = await getDataFromLocalDb(
          orderType === OrderType.SECONDARY ? "Catalogue" : "PrimaryCatalogue",
          query
        );
        setCatalogue(responseSelectedCatalogue?.data);
        setCart(responseCart?.data?.[0]?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    };
    getAndSetData();
  }, []);

  const handleClickViewDetails = (product: CartProduct) => {
    setSkuData(getSkuData(product) ?? {});
    dispatch(setDiscountModalState(true));
  };

  const handleClickReset = () => {
    const updatedGenericModalProps = getGenericModalProps(
      `positive`,
      `Are you sure you want to reset the cart?`,
      `Confirm`,
      `Cancel`,
      async () => {
        await resetCart()
        setGenericModalProps(initialGenericModalProps)
      },
      () => setGenericModalProps(initialGenericModalProps),
    );
    setGenericModalProps(updatedGenericModalProps);
  }

 useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check if user is not typing in an input field
      const activeElement = document.activeElement;
      const isTyping = activeElement?.tagName === 'INPUT' || 
                       activeElement?.tagName === 'TEXTAREA' ||
                       activeElement?.getAttribute('contenteditable') === 'true';

      // Prevent shortcuts when typing, loading, or when cart is empty
      if (isTyping || loading || placeOrderLoading || !outletId || outletId === 'null') {
        return;
      }

      // Ctrl+A (or Cmd+A) for checkout
      if ((event.ctrlKey || event.metaKey) && event.key?.toLocaleLowerCase() === 'a' && !genericModalProps?.open) {
        event.preventDefault();
        if (cart?.[outletId]?.productsMap !== undefined) {
          handleCheckoutLog();
        }
      }

      // Ctrl+Z (or Cmd+Z) for reset
      if ((event.ctrlKey || event.metaKey) && event.key?.toLocaleLowerCase() === 'z') {
        event.preventDefault();
        // Only trigger reset if there are items in cart
        const itemsCount = Object.keys(cart?.[outletId]?.productsMap ?? {})?.length;
        if (itemsCount > 0) {
          handleClickReset();
        }
      }

      // Ctrl+K (or Cmd+K) for add more
      if ((event.ctrlKey || event.metaKey) && event.key?.toLocaleLowerCase() === 'k') {
        event.preventDefault();
        handleStepperBack();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [loading, placeOrderLoading, outletId, cart, genericModalProps]);

  const itemsCount = Object.keys(cart?.[outletId]?.productsMap ?? {})?.length;

  return (
    <div className="checkout_container" style={{paddingBottom: "10px"}}>
      <ScreenOverlay apply={loading || placeOrderLoading} />
      {loading ? (
        <Loader />
      ) : (
        <>
         <CustomGenericModal
            type={genericModalProps?.type}
            message={genericModalProps?.message}
            leftButtonText={genericModalProps?.leftButtonText}
            rightButtonText={genericModalProps?.rightButtonText}
            modalOpen={genericModalProps?.open}
            onLeftButtonClick={genericModalProps?.onLeftButtonClick}
            onRightButtonClick={genericModalProps?.onRightButtonClick}
            onClose={() => setGenericModalProps(initialGenericModalProps)}
          />



          <div style={{display: "flex", flexDirection: "column", height: "100%", width: "100%"}}>
            <div style={{flexGrow: 0, height: "25px"}}>
            <FormHeader
            parentLabel={"Place New Order"}
            label={"Check out"}
            goBackToParent={handleStepperBack}
          />
            </div>
            <div style={{flexGrow: 1, overflow: "hidden"}}>
            <div className="checkout_grid_container" style={{height: "100%"}}>
            <div style={{ height: "100%", width: "58.5%" }}>
              <div>
                <div>
                  <div className="checkout_add_reset_total_product">
                    <span
                      style={{
                        fontSize: "16px",
                        color: "#227c9d",
                        fontWeight: 500,
                        marginLeft: "0.6rem",
                      }}
                    >
                      {itemsCount} {itemsCount > 1 ? "Products" : "Product"}
                    </span>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <Button
                        color="primary"
                        style={{
                          border: "#2b82a1 solid 1px",
                          backgroundColor: "#ffffff",
                          fontSize: "10px",
                          fontWeight: 600,
                          textTransform: "none",
                          padding: "2px 8px",
                        }}
                        onClick={handleClickReset}
                      >
                        <div
                          style={{
                            height: "24px",
                            width: "19px",
                            paddingRight: "4px",
                          }}
                        >
                          <RenderSvg name={"backIcon"} />
                        </div>
                        Reset
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{
                          fontSize: "11px",
                          padding: "0 11px",
                          fontWeight: 600,
                          textTransform: "none",
                        }}
                        sx={{
                          ":hover": {
                            boxShadow: "none",
                            background: "primary",
                          },
                          boxShadow: "none",
                        }}
                        onClick={() => {
                          handleStepperBack();
                        }}
                      >
                        <ShoppingCartIcon
                          style={{
                            height: "22px",
                            width: "14px",
                            marginRight: "4px",
                          }}
                        />
                        Add More
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="product-list-grid">
                {Object.values(cart?.[outletId]?.productsMap ?? {})
                  .map((product, _, arr) => {
                    return (
                      <CartProductCard
                        key={product.batchCode}
                        product={product}
                        updateQuantityInCart={updateQuantityInCart}
                        orderType={orderType}
                        handleClickViewDetails={handleClickViewDetails}
                        totalProducts={arr?.length ?? 0}
                        resetCart={resetCart}
                        customerInfo={cart?.[outletId]?.customer}
                        setCart={setCart}
                        catalogue={catalogue}
                        disableStockCheck={disableStockCheck.current}
                        enableMOQCheck = {enableMOQCheck}
                      />
                    );
                  })}
              </div>
            </div>
            <div className="checkout_customer_details_grid_container" style={{ height: "100%" }}>
              <SimpleBar className="customer_details_checkout" style={{overflowY: "auto", paddingBottom: "10px"}}>
                <div className="sub_header">
                  <div className="confirmed_order_icon">
                    <RenderSvg name="customerIcon" />
                  </div>
                  <Typography
                    sx={{ fontSize: "16px !important", color: "#227c9d", fontWeight: 500 }}
                  >{`${
                    orderType === OrderType.PRIMARY ? "Delivery" : "Customer"
                  } Details`}</Typography>
                </div>

                <Divider sx={{ height: "14px" }} color="#f1f1f1" />

                {orderType === OrderType.SECONDARY && (
                  <div className="checkout_summary_label_value_container">
                    <Typography className="label">{"Customer"}</Typography>
                    <Typography className="value">
                      {`${
                        cart?.[outletId]?.customer?.outletCode
                          ? cart?.[outletId]?.customer?.outletCode + " -"
                          : "-"
                      }  ${cart?.[outletId]?.customer?.outletName || ""}`}
                    </Typography>
                  </div>
                )}

                {orderType === OrderType.SECONDARY && (
                  <div className="checkout_summary_label_value_container">
                    <Typography className="label">{"Sales Rep"}</Typography>
                    <Typography className="value">
                      {cart?.[outletId]?.customer?.selectedSalesRep || "-"}
                    </Typography>
                  </div>
                )}
                {orderType === OrderType.PRIMARY ? (
                  <></>
                ) : (
                  <div className="checkout_summary_label_value_container">
                    <Typography className="label">{"Sales Type"}</Typography>
                    <Typography className="value">
                      {cart?.[outletId]?.customer?.salesType || "-"}
                    </Typography>
                  </div>
                )}
                {orderType === OrderType.SECONDARY && (
                  <div className="checkout_summary_label_value_container">
                    <Typography className="label">{"Sales Channel"}</Typography>
                    <Typography className="value">
                      {cart?.[outletId]?.customer?.customerChannel || "-"}
                    </Typography>
                  </div>
                )}
                <div className="checkout_summary_label_value_container">
                  <Typography className="label">{"Address"}</Typography>
                  <Typography className="value">
                    {cart?.[outletId]?.customer?.shippingAddress || "-"}
                  </Typography>
                </div>
                <div className="checkout_summary_label_value_container">
                  <Typography className="label">{"Bill Date"}</Typography>
                  <Typography className="value">
                    {formatDate(cart?.[outletId]?.customer?.billDate) || "-"}
                  </Typography>
                </div>
                <div className="checkout_summary_label_value_container">
                  <Typography className="label">{"Delivery Date"}</Typography>
                  <Typography className="value">
                    {formatDate(cart?.[outletId]?.customer?.deliveryDate) || "-"}
                  </Typography>
                </div>

                <div className="checkout_summary_label_value_container">
                  <Typography className="label">{"Payment Method"}</Typography>
                  <Typography className="value">
                    {cart?.[outletId]?.customer?.paymentMethod || "-"}
                  </Typography>
                </div>

                <Divider sx={{ height: "15px" }} color="#fff" />

                <div className="checkout_delivery_details">
                  {orderType === OrderType.SECONDARY && (
                    <div className="sub_header">
                      <div className="confirmed_order_icon">
                        <RenderSvg name="customerIcon" />
                      </div>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          color: "#227c9d",
                          fontWeight: 500,
                        }}
                      >
                        Delivery Details
                      </Typography>
                    </div>
                  )}
                  <DeliveryDetails
                    editedShippingAddress={
                      cart?.[outletId]?.customer?.differentShippingAddress ?? ""
                    }
                    cart={cart}
                    outletId={outletId}
                  />
                </div>
              </SimpleBar>
            </div>
          </div>
            </div>
            <div style={{flexGrow: 0, position: "relative"}}>
            <div className="Checkout_cartSummaryFooter_container_wrapper" style={{position: "static", padding: 0}}>
            <div className="Checkout_cartSummaryFooter_container">
              <CartSummaryFooter
                cartProducts={cartProducts}
                onButtonClick={handleCheckoutLog}
                buttonText={"Check Out"}
                loading={placeOrderLoading}
              />
            </div>
          </div>
            </div>
          </div>
         
         
         
        </>
      )}
      <NewDiscountModal
        selectedSkuCode={skuData?.productUI?.batchCode}
        skuData={skuData}
        showFooter={false}
        qtyLabel="In Stock"
        showMrpAndPackSize={true}
        slabTransformation={false}
      />
    </div>
  );
};

export default Checkout;
